import { render, staticRenderFns } from "./_spinner_id.vue?vue&type=template&id=51e9f79d&scoped=true&"
import script from "./_spinner_id.vue?vue&type=script&lang=js&"
export * from "./_spinner_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e9f79d",
  null
  
)

export default component.exports